import React from 'react'
import clsx from 'clsx'
import useStyles from './styles'

type BlockquoteProps = {
  children: React.ReactNode[]
}

const Blockquote: React.FC<BlockquoteProps> = ({ children = [] }) => {
  const cleanChildren = children.filter(child => child !== '\n')
  const classes = useStyles()
  return <blockquote className={clsx(classes.root)}>{cleanChildren}</blockquote>
}

export default Blockquote
